var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from 'aurelia-templating';
import { autoinject, transient } from 'aurelia-dependency-injection';
var ManageDepartment = /** @class */ (function () {
    function ManageDepartment() {
    }
    Object.defineProperty(ManageDepartment.prototype, "departmentParameters", {
        get: function () {
            return this.branchId + "," + this.department.departmentId;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        bindable(),
        __metadata("design:type", Object)
    ], ManageDepartment.prototype, "department", void 0);
    __decorate([
        bindable(),
        __metadata("design:type", Number)
    ], ManageDepartment.prototype, "branchId", void 0);
    ManageDepartment = __decorate([
        autoinject,
        transient()
    ], ManageDepartment);
    return ManageDepartment;
}());
export { ManageDepartment };
